<template>
  <div class="search-bar-container">
    <span class="material-icons search-icon">search</span>
    <input
      type="text"
      v-model="query"
      @input="onSearch"
      placeholder="Suche nach einer Adresse"
      class="search-bar"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      query: "",
    };
  },
  methods: {
    onSearch() {
      this.$emit("search", this.query);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");

.search-bar-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2.5rem;
  position: relative;
  width: 50%;
}

.search-bar {
  width: 100%;
  padding: 1rem 2.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-size: 1rem;
  outline: none;
}

.search-bar:focus {
  border-color: #000;
}

.search-icon {
  position: absolute;
  left: 10px;
  font-size: 24px;
  color: #777;
}
</style>
